import type { FCWithChildren } from '@pbk-web/types';
import type { ReactNode } from 'react';

import type { EditorFeature } from './context/FeaturesContext';

/** Wraps the editor in each enabled feature's `Provider`, in registry order (first is outermost). */
export const FeatureProviders: FCWithChildren<{ features: readonly EditorFeature[] }> = ({ features, children }) =>
  features.reduceRight<ReactNode>((inner, { name, Provider }) => (Provider ? <Provider key={name}>{inner}</Provider> : inner), children);
